export default __webpack_public_path__ + "static/media/bergen_lufthavn2.0fc4f702.jpg";